import { render, staticRenderFns } from "./problem_table_list.vue?vue&type=template&id=0c03790b&scoped=true"
import script from "./problem_table_list.vue?vue&type=script&lang=js"
export * from "./problem_table_list.vue?vue&type=script&lang=js"
import style0 from "./problem_table_list.vue?vue&type=style&index=0&id=0c03790b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c03790b",
  null
  
)

export default component.exports